export const GOOGLE_URL = "https://podcasts.google.com/feed/aHR0cHM6Ly9mZWVkcy5idXp6c3Byb3V0LmNvbS8yMjM1MTAwLnJzcw=="
export const SPOTIFY_URL = "https://open.spotify.com/show/1FQRjlKYqxnsGNEzDq40Gu"
export const INSTAGRAM_URL = "https://www.instagram.com/_mvnny.fitness/"
export const  YOUTUBE_URL = "https://www.youtube.com/@MvnnyFitness1"